module.exports = __webpack_public_path__ + "img/icon_event_white.4adafa51.svg";